/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Fonts_Add_Font_Button_LabelInputs */

const en_options_fonts_add_font_button_label = /** @type {(inputs: Options_Fonts_Add_Font_Button_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert new font`)
};

const fr_options_fonts_add_font_button_label = /** @type {(inputs: Options_Fonts_Add_Font_Button_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insérer une nouvelle police`)
};

const de_options_fonts_add_font_button_label = /** @type {(inputs: Options_Fonts_Add_Font_Button_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Schriftart einfügen`)
};

const it_options_fonts_add_font_button_label = /** @type {(inputs: Options_Fonts_Add_Font_Button_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci nuovo font`)
};

const ru_options_fonts_add_font_button_label = /** @type {(inputs: Options_Fonts_Add_Font_Button_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить новый шрифт`)
};

const es_options_fonts_add_font_button_label = /** @type {(inputs: Options_Fonts_Add_Font_Button_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar nueva fuente`)
};

const zh_cn2_options_fonts_add_font_button_label = /** @type {(inputs: Options_Fonts_Add_Font_Button_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入新字体`)
};

const ja_options_fonts_add_font_button_label = /** @type {(inputs: Options_Fonts_Add_Font_Button_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいフォントを挿入`)
};

const hi_options_fonts_add_font_button_label = /** @type {(inputs: Options_Fonts_Add_Font_Button_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया फ़ॉन्ट डालें`)
};

const pt_pt2_options_fonts_add_font_button_label = /** @type {(inputs: Options_Fonts_Add_Font_Button_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir nova fonte`)
};

/**
* | output |
* | --- |
* | "Insert new font" |
*
* @param {Options_Fonts_Add_Font_Button_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_fonts_add_font_button_label = /** @type {((inputs?: Options_Fonts_Add_Font_Button_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Fonts_Add_Font_Button_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_fonts_add_font_button_label(inputs)
	if (locale === "de") return de_options_fonts_add_font_button_label(inputs)
	if (locale === "it") return it_options_fonts_add_font_button_label(inputs)
	if (locale === "ru") return ru_options_fonts_add_font_button_label(inputs)
	if (locale === "es") return es_options_fonts_add_font_button_label(inputs)
	if (locale === "zh-CN") return zh_cn2_options_fonts_add_font_button_label(inputs)
	if (locale === "ja") return ja_options_fonts_add_font_button_label(inputs)
	if (locale === "hi") return hi_options_fonts_add_font_button_label(inputs)
	if (locale === "pt-PT") return pt_pt2_options_fonts_add_font_button_label(inputs)
	return en_options_fonts_add_font_button_label(inputs)
});